/** @format */

import React from "react";
import MainContentContainer from "./MainContent.container";

interface IRegistrationFormProps {
	sitekey: string;
	onSuccess: () => void;
}

const MainContent: React.FC<IRegistrationFormProps> = ({
	sitekey,
	onSuccess,
}) => <MainContentContainer sitekey={sitekey} onSuccess={onSuccess} />;

export default MainContent;
